import { useDebounce } from "@uidotdev/usehooks";
import { useMemo, useState } from "react";
import type { LexiconConceptResponse } from "@noa/api-core";
import type { AppLanguageType } from "@noa/i18n";

export function useFilteredConcepts(concepts: LexiconConceptResponse[], language: AppLanguageType) {
  const [isSortAsc, setIsSortAsc] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);

  const filteredConcepts = useMemo(() => {
    const term = debouncedSearch.trim().toLowerCase();
    const filtered = term
      ? concepts.filter((c) => {
          const t = language === "fr" ? c.term_fr : c.term_en;
          const d = language === "fr" ? c.description_fr : c.description_en;
          const s = language === "fr" ? c.synonyms_fr : c.synonyms_en;
          return (
            t.toLowerCase().includes(term) ||
            d.toLowerCase().includes(term) ||
            s.some((syn) => syn.toLowerCase().includes(term))
          );
        })
      : concepts;
    return [...filtered].sort((a, b) => {
      const ta = language === "fr" ? a.term_fr : a.term_en;
      const tb = language === "fr" ? b.term_fr : b.term_en;
      return isSortAsc ? ta.localeCompare(tb) : tb.localeCompare(ta);
    });
  }, [concepts, language, debouncedSearch, isSortAsc]);

  return { filteredConcepts, isSortAsc, setIsSortAsc, search, setSearch };
}
